<template>
    <svg width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
        <!-- @vue-ignore -->
        <path
            d="M20.392 8.293a1 1 0 0 1 0 1.414l-6.364 6.364 6.364 6.364a1 1 0 0 1-1.414 1.414l-7.07-7.07a1 1 0 0 1 0-1.415l7.07-7.071a1 1 0 0 1 1.414 0Z"
            fill="currentColor"
            fill-rule="evenodd"
        />
    </svg>
</template>
